import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import global_en from './translations/en/global.json';
import global_sk from './translations/sk/global.json';
import global_cz from './translations/cz/global.json';

import i18next from 'i18next';
import App from './App';

import './css/root.css';
import './css/main.css';
import './css/tab_menu.css';
import './css/user_menu_override.css';
import './css/typing.css';

import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from './context/AuthProvider';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

i18next.init({
  interpolation: { escapeValue: true },
  lng: 'en',
  resources: {
    en: { global: global_en },
    sk: { global: global_sk },
    cz: { global: global_cz }
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<React.StrictMode>
  <BrowserRouter basename="/">
    <I18nextProvider i18n={i18next}>
      <AuthProvider>
        <Routes>
          <Route path="/*" element={ <App/> } />
        </Routes>     
      </AuthProvider>
    </I18nextProvider>   
  </BrowserRouter>
</React.StrictMode>  
);

reportWebVitals();
